define.alias("ember-composable-helpers/helpers/has-next", "calendar/helpers/has-next");